import { sendWebsocketMessage } from '../../../../../App';

export function requestUserPreferences() {
  const msg = {
    messageType: 'userPreferences'
  }

  sendWebsocketMessage(msg)
}